import './App.css';
import {Routes, Route, useNavigate } from 'react-router-dom';

import { Security, LoginCallback, useOktaAuth } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";

import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import Instructions from "./Pages/Instructions";
import RedirectPage from "./Pages/RedirectPage";
import Header from "./Components/Header";
import TestAPI from './Pages/TestAPI';
import { useEffect } from 'react';
import Log from './Pages/Log'
import "bootstrap/dist/css/bootstrap.min.css";

const issuer = process.env.REACT_APP_OKTA_ISSUER;
const clientId = process.env.REACT_APP_OKTA_CLIENTID;
const redirect = process.env.REACT_APP_OKTA_APP_REDIRECT_URL;

const oktaAuth = new OktaAuth({
  issuer: issuer,
  clientId: clientId,
  redirectUri: window.location.origin + redirect
});

function App() {

  const history = useNavigate(); //BrowserRouter must be a Ancestor/Parent to any component using this

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history(toRelativeUrl(originalUri || '/', window.location.origin), {replace: true})
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} >
      <div className="App">
        <Header/>
        <main>
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/index.html" element={<Home/>} />
            <Route path="/redirect" element={<RedirectPage/>} />
            <Route path="/login/callback" element={<LoginCallback/>} />
            <Route path="/instructions" element={<Instructions/>} />
            <Route path="/profile" element={<Profile/>} />
            <Route path="/testapi" element={<TestAPI/>} />
            <Route path="/log" element={<Log/>} />
          </Routes>
        </main>
      </div>
    </Security>
  );
}

export default App;
